import React, { Component } from 'react';
import classNames from 'classnames/bind';

import SearchTabName from '~/components/legacy/SearchTabName.jsx';
import legacyEventHub from '~/modules/legacyRuntime.js';

class SearchTabs extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleGlobalClosePopupMenus = this.handleGlobalClosePopupMenus.bind(this);
    this.handleGlobalFireSearch = this.handleGlobalFireSearch.bind(this);
    this.isControlled = this.isControlled.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
    this.updateBodyMenuState = this.updateBodyMenuState.bind(this);

    this.state = {
      activeTab : this.props.activeTab
    }
  }

  isControlled() {
    return typeof this.props.onActiveTabChange === 'function';
  }

  updateBodyMenuState(activeTab) {
    if (typeof document === 'undefined' || !document.body) {
      return;
    }

    document.body.classList.toggle('search-menu-open', activeTab !== 0);
  }

  componentDidMount() {
      this.updateBodyMenuState(this.state.activeTab);

      const eventHub = this.eventHub();
      if (eventHub && typeof eventHub.on === 'function') {
        eventHub.on('fireSearch', this.handleGlobalFireSearch);
        eventHub.on('closePopupMenus', this.handleGlobalClosePopupMenus);
      }
  }

  componentDidUpdate(prevProps, prevState) {
      if (this.isControlled() && this.props.activeTab !== prevProps.activeTab && this.props.activeTab !== this.state.activeTab) {
        this.setState({
          activeTab : this.props.activeTab
        }, function() {
          this.updateBodyMenuState(this.props.activeTab);
        }.bind(this));
        return;
      }
  }

  componentWillUnmount() {
      this.updateBodyMenuState(0);

      const eventHub = this.eventHub();
      if (eventHub && typeof eventHub.off === 'function') {
        eventHub.off('fireSearch', this.handleGlobalFireSearch);
        eventHub.off('closePopupMenus', this.handleGlobalClosePopupMenus);
      }
  }

  eventHub() {
      return legacyEventHub;
  }

  handleGlobalFireSearch() {
      this.setActiveTab(0);
  }

  handleGlobalClosePopupMenus() {
      this.setActiveTab(0);
  }

  setActiveTab(activeTab) {
      if (this.state.activeTab === activeTab) {
        return;
      }

      if (this.isControlled()) {
        this.props.onActiveTabChange(activeTab);
      }

      this.setState({
        activeTab : activeTab
      }, function() {
        this.updateBodyMenuState(activeTab);
      });
  }

  handleChange(newIndex) {
      const activeTab = this.state.activeTab === newIndex ? 0 : newIndex;
      const eventHub = this.eventHub();

      this.setActiveTab(activeTab);

      if (eventHub && typeof eventHub.trigger === 'function') {
        eventHub.trigger('searchTabNavClicked');
      }
  }

  // getTabNavChildren() {
  //     var children = this.props.children,
  //         activeTabIndex = this.state.activeTab,
  //         index = 0,
  //         handleChange = this.handleChange;

  //     return React.Children.map(children, function(child) {
  //         index += 1;

  //         return (
  //           <SearchTabNavItem
  //             title={child.props.title}
  //             highlighted={child.props.highlighted}
  //             counter={child.props.counter}
  //             iconClassName={child.props.iconClassName}
  //             ref={'search-tab-nav-item-' + index}
  //             index={index}
  //             handleChange={handleChange}
  //             active={index === activeTabIndex} />
  //         )
  //     });
  // }

  getTabContentChildren() {
      var children = this.props.children,
          activeTabIndex = this.state.activeTab,
          index = 0,
          handleChange = this.handleChange;

      return React.Children.map(children, function(child) {
          if (!child) {
            return null;
          }

          index += 1;

          if (child.props.itemNames) {
              return React.Children.map(child.props.children, function(tabContent) {
                  var classesSearchTab = classNames({
                    'search-tab' : true,
                    'search-tab--last' : (index === children.length),
                    'search-tab--instruments' : (child.props.itemNames === 'instruments'),
                    'search-tab--moods' : (child.props.itemNames === 'moods'),
                    'search-tab--genres' : (child.props.itemNames === 'genres'),
                    [child.props.className]: !!child.props.className
                  });

                  return (
                    <div className={classesSearchTab}>
                      <SearchTabName
                        title={child.props.title}
                        highlighted={child.props.highlighted}
                        counter={child.props.counter}
                        iconClassName={child.props.iconClassName}
                        ref={'search-tab-nav-item-' + index}
                        index={index}
                        activeItems={child.props.activeItems}
                        proFilter={child.props.proFilter}
                        items={child.props.items}
                        handleChange={handleChange}
                        active={index === activeTabIndex}
                        locale={child.props.locale}
                        />
                      {index === activeTabIndex ? tabContent : ''}
                    </div>
                  )
              });
          } else {
              // length inputs & query input
              return child;
          }


      });
  }

                  // <SearchTab ref={'tab-nav-item-' + index} index={index} handleChange={handleChange} active={index === activeTabIndex}>
                  //   {tabContent}
                  // </SearchTab>

  render() {
      let classes = classNames({
            'search-tabs' : true,
            'search-tabs--horizontal' : this.props.alignment === 'horizontal',
            'search-tabs--vertical' : this.props.alignment === 'vertical'
          });

      return (
        <div className={classes}>
          {this.getTabContentChildren()}
        </div>
      )

  }
};

SearchTabs.defaultProps = {
  activeTab : 0,
  alignment : 'horizontal', // 'horizontal' or 'vertical'
  onActiveTabChange : null
}

export default SearchTabs;
